import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";


import Payment from "../../assets/img/mywork/Payment Automation.JPG";

import Probe from "../../assets/img/mywork/InsuranceProbe.JPG";

import Virtual from "../../assets/img/mywork/VirtualInsurance.jpeg";

import Insurance from "../../assets/img/mywork/Insurance.JPG";

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import image from "assets/img/mywork/mywork.jpg";

const useStyles = makeStyles(styles);

export default function MyWork(props) {
    const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
    setTimeout(function () {
        setCardAnimation("");
    }, 700);
    const classes = useStyles();
    const { ...rest } = props;
    return (
        <div>
            <Header
                absolute
                color="transparent"
                brand="Rachit Mehrotra.io"
                rightLinks={<HeaderLinks />}
                {...rest}
            />
            <div
                className={classes.pageHeader}
                style={{
                    backgroundImage: "url(" + image + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "top center",
                }}
            >
                <div className={classes.container}>
                    <h3>My Work</h3>
                    <GridContainer justify="center">

                        <GridItem xs={12} sm={12} md={4}>

                            <Card className={classes[cardAnimaton]}>
                                <a
                                    href="https://rm-insurance-probe-v1.firebaseapp.com/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    color="rose"
                                    className={classes.navLink}
                                >
                                    <img src={Probe} alt="Logo" width="370" height="300" />
                                </a>
                            </Card>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={4}>
                            <Card className={classes[cardAnimaton]}>
                                <a
                                    href="https://facebook-insurance-twin.web.app/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    color="rose"
                                    className={classes.navLink}
                                >
                                    <img src={Insurance} alt="Logo" width="370" height="300" />
                                </a>
                            </Card>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={4}>
                            <Card className={classes[cardAnimaton]}>
                                <a
                                    href={Payment}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    color="rose"
                                    className={classes.navLink}
                                >
                                    <img src={Payment} alt="Logo" width="370" height="300" />
                                </a>
                            </Card>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={4}>
                            <Card className={classes[cardAnimaton]}>
                                <a
                                    href={Virtual}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    color="rose"
                                    className={classes.navLink}
                                >
                                    <img src={Virtual} alt="Logo" width="370" height="300" />
                                </a>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
                <Footer whiteFont />
            </div>
        </div>
    );
}
